// Client registration accepts any URL scheme, and desktop MCP clients use their own
// (cursor://, vscode://), so only schemes that run code in our origin are refused.
const SCRIPT_SCHEMES = new Set(['javascript:', 'data:', 'vbscript:', 'blob:', 'file:']);

export function isSafeRedirectUri(uri) {
  try {
    return !SCRIPT_SCHEMES.has(new URL(uri).protocol);
  } catch {
    return false;
  }
}
